<template>
  <div class="trail-comments">
    <comments-form class="mb-5" @success="refresh(true)" :resource="resource" />

    <action-dispatcher
      action="comments/get"
      :parameters="{ id: resource, limit, offset }"
      ref="commentsGet"
      always-show-slot
    >
      <comment
        v-for="comment in comments"
        :key="comment.id"
        :comment="comment"
        @edit="openEdit"
        @remove="openRemove"
        @reply="reply"
      />
    </action-dispatcher>

    <div v-if="count > comments.length" class="text-center">
      <button class="btn btn-load-more rounded-pill" @click="loadMore">
        VER MAIS
      </button>
    </div>

    <confirmation
      v-model="removeDialog"
      @confirm="remove"
      text="Tem certeza que deseja remover comentário?"
      confirm-button-text="Remover"
    />

    <b-modal v-model="replyDialog" hide-header hide-footer centered>
      <comments-form
        @success="refresh(true)"
        :parent="selectedComment"
        :resource="resource"
      />
    </b-modal>

    <b-modal v-model="editDialog" hide-header hide-footer centered>
      <comments-form
        @success="refresh(true)"
        :comment="selectedComment"
        :resource="resource"
      />
    </b-modal>
  </div>
</template>

<script>
import Comment from "./Comment";
import CommentsForm from "./CommentsForm";
import { mapState } from "vuex";

export default {
  components: { CommentsForm, Comment },
  props: {
    resource: [String, Number]
  },
  data() {
    return {
      replyDialog: false,
      offset: 0,
      limit: 5,
      selectedComment: null,
      editDialog: false,
      removeDialog: false
    };
  },
  computed: {
    ...mapState("comments", ["comments", "count"])
  },
  beforeMount() {
    this.$store.dispatch("comments/reset");
  },
  methods: {
    reply(comment) {
      this.selectedComment = comment.id;
      this.replyDialog = true;
    },
    remove() {
      this.$store
        .dispatch("comments/remove", this.selectedComment.id)
        .then(() => {
          this.$message.success("Comentário removido com sucesso");
          this.refresh(true);
        })
        .catch(() => {
          this.$message.error("Erro");
        });
    },
    openEdit(comment) {
      this.editDialog = true;
      this.selectedComment = comment;
    },
    openRemove(comment) {
      this.removeDialog = true;
      this.selectedComment = comment;
    },
    refresh(reset = false) {
      if (reset) {
        this.$store.dispatch("comments/reset");
      }
      this.editDialog = false;
      this.replyDialog = false;
      this.$refs.commentsGet.dispatch();
    },
    loadMore() {
      this.offset += this.limit;
      setTimeout(() => {
        this.refresh();
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-comments {
  .btn-load-more {
    font-size: 14px;
    line-height: 21px;
    padding: 10px 32px;
    font-weight: 500;
    background: #1c1c1c;
    color: white;

    &:hover {
      background: #191919;
    }
  }
}
</style>
